import React, { InputHTMLAttributes } from "react";
import styles from "./style.module.css";

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  style?: React.CSSProperties;
}

export default function Textarea({ style, ...res }: Props) {
  return <textarea className={styles.textarea} style={{ ...style }} {...res} />;
}
